export enum TransfersTypes {
  REGULAR_TRANSFER = 1,
  LOAN = 2,
}
